import React from 'react'
import { mergeClassnames } from '@mote/helpers'
import { __DEV__ } from '@mote/helpers/constants'
import styled, { css, th } from '@xstyled/styled-components'

export const TableRow = React.forwardRef(
  (
    { className, as = 'tr', hover = false, selected = false, ...props },
    ref
  ) => {
    return (
      <TableRowRoot
        as={as}
        className={mergeClassnames('mote-table-row', className)}
        ref={ref}
        role={as === 'tr' ? null : 'row'}
        hover={hover}
        selected={selected}
        {...props}
      />
    )
  }
)

if (__DEV__) {
  TableRow.displayName = 'TableRow'
}

const TableRowRoot = styled.trBox`
  color: inherit;
  display: table-row;
  vertical-align: middle;
  outline: 0;

  &:hover,
  &:focus {
    background-color: ${({ hover }) =>
      th.color(hover ? 'grey.l4' : 'transparent')};
  }

  ${({ selected }) =>
    selected &&
    css`
      background-color: ${th.color('grey.l4')};

      &:hover,
      &:focus {
        background-color: ${th.color('grey.l3')};
      }
    `}
`
